// Only these imports are used by ag-grid.
// DO NOT ADD EXPORTS UNLESS REQUIRED BY INTEGRATED CHARTS.
export { Color } from 'ag-charts-core';
export { interpolateColor } from './util/interpolate';
